
import { HOME_CATEGORY_ENTRIES } from '@/config/homeEntries'
import { specResultQuery } from '@/utils/searchEntries'

// 首页黄金入口（Merchandising Phase 2，spec §17）：运营槽位 API 主源，
// 无配置/接口失败 → HOME_CATEGORY_ENTRIES 写死数组（§28 数据兼容，首页永不空）。
// 部分配置语义：已配 hub 槽在前，未配满 4 位用写死类目补齐（跳过同 slug），
// 第 5 位恒「更多」（§16）——API 的 more 位优先，缺失也强制补写死「更多」。
const FALLBACK_MORE = HOME_CATEGORY_ENTRIES.find(e => e.type === 'all_categories')
const FALLBACK_HUBS = HOME_CATEGORY_ENTRIES.filter(e => e.type === 'category_hub')

export default {
  name: 'CategoryEntries',
  data () {
    return { entries: HOME_CATEGORY_ENTRIES }
  },
  created () {
    this.fetchSlots()
  },
  methods: {
    async fetchSlots () {
      try {
        const res = await this.axios.get('/merchandising/home-slots')
        const slots = (res.data && res.data.code === 200 && res.data.data) || []
        if (!Array.isArray(slots) || slots.length === 0) return // 全 fallback：保持写死数组
        const hubs = slots.filter(s => s.slug).map(s => ({
          title: s.title, icon: s.icon || 'grid', tone: s.accent_color || 'blue',
          type: 'hub', slug: s.slug
        }))
        const apiMore = slots.find(s => !s.slug)
        const seen = new Set(hubs.map(h => h.slug))
        for (const f of FALLBACK_HUBS) {
          if (hubs.length >= 4) break
          if (!seen.has(f.target)) {
            hubs.push({
              title: f.title,
              icon: f.icon,
              tone: f.tone,
              type: 'category_hub',
              target: f.target,
              search_alias: f.search_alias
            })
          }
        }
        const more = apiMore
          ? { title: apiMore.title || '更多', icon: apiMore.icon || 'grid', tone: 'neutral', type: 'all_categories' }
          : { ...FALLBACK_MORE }
        this.entries = [...hubs.slice(0, 4), more]
      } catch (_) {
        // 接口失败：保持写死数组（§28），不重试不打扰
      }
    },
    onEntry (e) {
      // 全类目浏览：现有 /search 页类目网格
      if (e.type === 'all_categories') return this.$router.push('/search')
      // 运营专区（hub 槽）：独立 landing /hub/:slug（spec §5）
      if (e.type === 'hub' && e.slug) return this.$router.push('/hub/' + e.slug)
      // category_hub（fallback 类目槽，非运营专区）：类目入口进规格筛选上下文
      // （/result?type=spec&category=<key>，类目默认全量，结果页可按规格/车型 facet 收窄），
      // 不再误走 /result?id=轮胎 关键词搜索；无 target 的异常配置兜底才回落关键词搜索
      if (e.type === 'category_hub' && e.target) {
        return this.$router.push({ path: '/result', query: specResultQuery({ category: e.target, categoryName: e.title }) })
      }
      this.$router.push({ path: '/result', query: { id: e.search_alias || e.title } })
    }
  }
}
